<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <navbar :show-back-button="false"></navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid class="fill-height">
      <v-row>
        <v-col>
      <v-row>
        <v-col class="text-center">
          <v-chip class="pl-6 pr-6" color="warning text--secondary" light x-large>
          <v-icon left>mdi-server-network-off</v-icon>The network has been disconnected, use the icon below to go to the home screen.
        </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">

        <v-card
          class="pa-2 primary secondary--text text--darken-3 homeCard ml-auto mr-auto"
          tile
          link
          @click="$router.push('home');"
        >
          <v-card-title class="justify-center">
            <v-avatar class="secondary darken-3" size="76">
              <v-avatar class="secondary lighten-1" size="70">
                <v-icon large class="display-2">mdi-home</v-icon>
              </v-avatar>
            </v-avatar>
          </v-card-title>
          <v-card-text class="justify-center text-center subtitle-1">Home</v-card-text>
        </v-card>
      </v-col>
      </v-row>
        </v-col>
      </v-row>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
};
</script>

<style>
.homeCard {
  width: 150px;
  height: 150px;
  margin: 20px;
}

</style>
